import type { ListResponse } from 'framework/list';
import { useRecruitmentApi } from 'infrastructure/api';
import type {
  SourcingCandidate,
  SourcingCandidatesSearchRequest,
  SourcingFilterOptions,
  SavedSourcingFilterParameters,
  SourcingSavedFilter,
} from './types';

const useRecruitmentPoolSourcingService = () => {
  const { sendDeleteRequest, sendGetRequest, sendPostRequest } = useRecruitmentApi();

  const getFilterOptions = async (recruitmentPoolId: string): Promise<SourcingFilterOptions> => {
    const response = await sendGetRequest(`/recruitment-pool/${recruitmentPoolId}/sourcing/filter-options`);

    return response.json();
  };

  const search = async (
    recruitmentPoolId: string,
    request: SourcingCandidatesSearchRequest,
  ): Promise<ListResponse<SourcingCandidate>> => {
    const response = await sendPostRequest(`/recruitment-pool/${recruitmentPoolId}/sourcing/search`, request);

    return response.json();
  };

  const getSavedFilters = async (recruitmentPoolId: string): Promise<SourcingSavedFilter[]> => {
    const response = await sendPostRequest(`/recruitment-pool/${recruitmentPoolId}/sourcing/saved-filters/search`, {
      pageNumber: 0,
      pageSize: 100,
    });
    const result = await response.json();
    return result.result ?? [];
  };

  const saveFilter = async (recruitmentPoolId: string, name: string, parameters: SavedSourcingFilterParameters) => {
    const response = await sendPostRequest(`/recruitment-pool/${recruitmentPoolId}/sourcing/saved-filters`, {
      name,
      parameters,
    });
    return response.json() as Promise<SourcingSavedFilter>;
  };

  const deleteSavedFilters = (recruitmentPoolId: string, ids: string[]) =>
    sendDeleteRequest(`/recruitment-pool/${recruitmentPoolId}/sourcing/saved-filters`, { ids });

  return { deleteSavedFilters, getFilterOptions, getSavedFilters, saveFilter, search };
};

export default useRecruitmentPoolSourcingService;
